// src/modules/financials/components/OverviewKPIs.jsx
import React from 'react';
import { Row, Col, Card, Statistic } from 'antd';
import {
  DollarOutlined,
  RiseOutlined,
  FallOutlined,
  ShoppingCartOutlined,
  GoldOutlined,
  PercentageOutlined,
  UserOutlined,
  SafetyOutlined,
} from '@ant-design/icons';

const inr = (v) => `₹${Number(v || 0).toLocaleString('en-IN')}`;

const KPICard = ({ title, value, prefix, suffix, color, icon }) => (
  <Card
    hoverable
    style={{ borderRadius: 12, border: '1px solid #f0f0f0', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}
    bodyStyle={{ padding: '20px 24px' }}
  >
    <Statistic
      title={<span style={{ fontSize: 13, color: '#8c8c8c' }}>{title}</span>}
      value={value}
      prefix={icon || prefix}
      suffix={suffix}
      valueStyle={{ color: color || '#262626', fontSize: 22, fontWeight: 600 }}
    />
  </Card>
);

const OverviewKPIs = ({ data = {} }) => {
  const capitalExposure = data.totalCapitalExposure
    ?? data?.capitalExposure?.totalExposure
    ?? data.totalPurchaseCost;
  const netWeightPurchased = data.totalNetWeightPurchased ?? data.totalWeightPurchased;
  const grossWeightPurchased = data.totalGrossWeightPurchased ?? data.totalWeightPurchased;

  const items = [
    {
      title: 'Capital Exposure',
      value: inr(capitalExposure),
      icon: <FallOutlined />,
      color: '#cf1322',
    },
    {
      title: 'Sold to Smelter',
      value: inr(data.totalSmelterSale),
      icon: <DollarOutlined />,
      color: '#13c2c2',
    },
    {
      title: 'Net Profit / Loss',
      value: inr(data.totalProfit),
      icon: <RiseOutlined />,
      color: data.totalProfit >= 0 ? '#3f8600' : '#cf1322',
    },
    {
      title: 'Total Bills',
      value: data.totalBills || 0,
      icon: <ShoppingCartOutlined />,
      color: '#1890ff',
    },
    {
      title: 'Net Weight Purchased (g)',
      value: `${Number(netWeightPurchased || 0).toLocaleString('en-IN')} g`,
      icon: <GoldOutlined />,
      color: '#d4a017',
    },
    {
      title: 'Gross Weight Purchased (g)',
      value: `${Number(grossWeightPurchased || 0).toLocaleString('en-IN')} g`,
      icon: <GoldOutlined />,
      color: '#b8860b',
    },
    {
      title: 'Processing Fees',
      value: inr(data.totalProcessingFees),
      icon: <PercentageOutlined />,
      color: '#722ed1',
    },
    {
      title: 'Walk-In Cases',
      value: data.totalWalkInCases || 0,
      icon: <UserOutlined />,
      color: '#1890ff',
    },
    {
      title: 'Pledge Cases',
      value: data.totalPledgeCases || 0,
      icon: <SafetyOutlined />,
      color: '#faad14',
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {items.map((item, i) => (
        <Col xs={24} sm={12} md={8} lg={6} key={i}>
          <KPICard {...item} />
        </Col>
      ))}
    </Row>
  );
};

export default OverviewKPIs;
